// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PlaceRewardsSection from '../../../organism/PlaceRewardsSection';

const PlaceRewardsView = ({ isBonusPointDayEnabled, isPlacePerkEnabled, ...otherProps }) => {
  return (
    <PlaceRewardsSection
      isBonusPointDayEnabled={isBonusPointDayEnabled}
      isPlacePerkEnabled={isPlacePerkEnabled}
      {...otherProps}
    />
  );
};

export default PlaceRewardsView;
